export default __webpack_public_path__ + "static/media/info.fdfc6919.svg";